// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#overlay[data-v-21ea376a]{position:absolute;top:0;left:0;height:100%;width:100%;background-color:transparent;background-image:linear-gradient(340deg,hsla(0,0%,39%,.361) 45%,#1eb0e1);opacity:1;mix-blend-mode:multiply;transition:background .3s,border-radius .3s,opacity .3s}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
